import { MenuItem, VueRouter } from "@abaco/web-common/src/app";

export function createMenu(router: VueRouter): MenuItem[] {
    return [
        {
            id: "processes-1",
            descrKey: "processes.list.title",
            icon: "abc-icon abc-icon-sheets",
            onClick: () => router.push({ name: "process-list" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "inspection-practices",
            descrKey: "inspection-practices",
            icon: "fal fa-bookmark",
            onClick: () => router.push({ name: "inspection-list" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "processes-old",
            descrKey: "old-processes",
            icon: "abc-icon abc-icon-sheets",
            onClick: () => router.push({ name: "processes-old" }),
            get isVisible() {
                return true;
            }
        },
        {
            id: "processes-old-subject",
            descrKey: "old-processes-subject",
            icon: "abc-icon abc-icon-sheets",
            onClick: () => router.push({ name: "processes-old-subject" }),
            get isVisible() {
                return true;
            }
        },
    ];
}

